export const COOLING_DURATION = 15000
export const COOLING_PERCENTAGE = 1

export const TOWER_STOP_PER_SECOND = 0.05
export const FULL_SPEED_DURATION = 30

export const MIN_TOWER_SPEED = 0.4
export const MAX_TOWER_SPEED = 10
